import { render, staticRenderFns } from "./TheStartup.vue?vue&type=template&id=0914bac0&scoped=true&"
import script from "./TheStartup.vue?vue&type=script&lang=js&"
export * from "./TheStartup.vue?vue&type=script&lang=js&"
import style0 from "./TheStartup.vue?vue&type=style&index=0&id=0914bac0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0914bac0",
  null
  
)

export default component.exports